<template>
    <b-modal :id="id"
             :no-close-on-backdrop="true"
             :title="$t('card.make_dir')" ref="innermodal" @shown="browseFile">
        <form ref="form">
            <b-form-group v-if="click=='isImg'">
                <input type="file" ref="img" hidden @change="onFileChange"/>
                <b-card>
                    <img :src="url" alt="IMAGE">
                </b-card>
            </b-form-group>
             <b-form-group :label="$t('label.name')" v-if="click=='isDir'">
                <input type="text" v-model="model.name" class="form-control" placeholder="Enter folder name"/>
            </b-form-group>
        </form>
        <div slot="modal-footer">
            <b-btn variant="primary" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('btn.make_dir')}}</b-btn>
        </div>
    </b-modal>
</template>
<script>
    export default {
        props:{
            id: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default: null
            },
            isUpdate: {
                type: Boolean,
                default: false
            },
            btnIsClick: {
                type: String,
                default: ''
            }
        },
        data: function(){
            return {
                model: {},
                update: this.isUpdate,
                url: null,
                click: this.btnIsClick
            }
        },
        methods: {
            clickSaveHandler(){
                if(this.click == 'isImg'){
                    this.$api().post('image/upload', this.model).then(() => {
                        this.$refs.innermodal.hide();
                        this.$emit('done')
                    });
                }
                else {
                    this.$api().post('create/directory', this.model).then(() => {
                        this.$refs.innermodal.hide();
                        this.$emit('done')
                    });
                }
            },
            browseFile: function(){
                if(this.click=='isImg'){
                    this.$refs.img.click();
                }
            },
            onFileChange(e) {
                const file = e.target.files[0];
                this.url = URL.createObjectURL(file);
            }
        },
        watch: {
            value: function(value){
                if(value != undefined && value != null){
                    this.model = value;
                }else{
                    this.model = {}
                }
            },
            isUpdate: function(value){
                this.update = value
            },
            btnIsClick: function(value){
                this.click = value
            }
        }
    }
</script>